import type {Conversation} from "@khan/guide-types";

/**
 * Get the interaction ID from the last message in a conversation.
 */
export const getLastInteractionId = (conversation: Conversation) => {
    return conversation.at(-1)?.interactionId ?? "";
};
